import { ModalWithHeader } from '@access-erp/ui-components';
import dayjs from 'dayjs';
import { useEffect } from 'react';

import { useGetSalesOrdersByBillingCyclePrediction }
  from '../PredictedActualTable/hooks/useGetSalesOrdersByBillingCyclePrediction';
import PredictedActualTable from '../PredictedActualTable/PredictedActualTable';

interface IPredictionTableModalProps {
  closeModal: () => void;
  isVisible: boolean;
}

export default function PredictionTableModal({
  closeModal,
  isVisible,
}: IPredictionTableModalProps) {
  const {
    getSalesOrdersByBillingCyclePrediction,
    salesOrdersByBillingCyclePrediction,
    isLoadingBillingCyclePrediction,
  } = useGetSalesOrdersByBillingCyclePrediction();

  const predictions = (salesOrdersByBillingCyclePrediction ?? [])
    .filter((item): item is NonNullable<typeof item> => item !== null);

  useEffect(() => {
    const currentDate = dayjs();
    const twoDaysFromNow = new Date(
      new Date(currentDate.subtract(2, 'day').format()).toUTCString(),
    );
    const tomorrow = new Date(new Date(currentDate.add(1, 'day').format()).toUTCString());

    getSalesOrdersByBillingCyclePrediction(twoDaysFromNow, tomorrow);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalWithHeader
      open={isVisible}
      title="Sales Orders Predictions vs Actual"
      onClose={() => closeModal()}
    >
      <div style={{ padding: '20px' }}>
        <PredictedActualTable
          isLoadingPrediction={isLoadingBillingCyclePrediction}
          salesOrdersPrediction={predictions}
          isBillingCyclesPath={true}
        />
      </div>
    </ModalWithHeader>
  );
}
